var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPencil = function SvgPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.532,
    height: 7.524,
    viewBox: "0 0 7.532 7.524",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.532,
    height: 7.524,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_1",
    "data-name": "Repeat Grid 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.467 -4.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(4.467 4.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25994",
    "data-name": "Path 25994",
    d: "M5.468,82.473,1.059,86.882a.176.176,0,0,0-.046.081L1,88.443a.174.174,0,0,0,.168.216.172.172,0,0,0,.042-.005L2.7,88.645a.173.173,0,0,0,.081-.046l4.409-4.409Zm0,0",
    transform: "translate(-1 -81.135)",
    fill: "#b5b5c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25995",
    "data-name": "Path 25995",
    d: "M336.647.983l-.491-.491a.889.889,0,0,0-1.227,0l-.6.6,1.718,1.718.6-.6a.868.868,0,0,0,0-1.227Zm0,0",
    transform: "translate(-329.369 -0.247)",
    fill: "#b5b5c3"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil.5ae0b125.svg";
export { ForwardRef as ReactComponent };